module.exports = __webpack_public_path__ + "static/media/menu-scene.995835c3.glb";